import { css } from 'styled-components';
import { mediaTemplates } from 'theme/variables';

const mediaQueries = css`
  ${mediaTemplates.xxs} {
    right: 24px;
  }
`;

export default mediaQueries;
